import script from "./CarteDigitale.vue?vue&type=script&setup=true&lang=js"
export * from "./CarteDigitale.vue?vue&type=script&setup=true&lang=js"

import "./CarteDigitale.vue?vue&type=style&index=0&id=4fab229b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fab229b"]])

export default __exports__